// extracted by mini-css-extract-plugin
module.exports = {"root":"Subheader-root-d988f12e7da805d60846b39bf80daaf9"};